export const nativeAppSwaUserAgentTokens: string[] = ["SWAIOSWebview", "SWAAndroidWebview"];
